<template>
  <div id="wrap" v-if="viewPopUp">
    <div class="jipvioPopUp">
      <header>
        <span class="btn-right" @click="close">
          <i class="el-icon-close"></i>
        </span>
        <slot name="header"></slot>
      </header>
      <section class="JipvioContainer">
        <slot name="container"></slot>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      viewPopUp: true
    };
  },

  methods: {
    close() {
      this.viewPopUp = !this.viewPopUp;
    }
  }
};
</script>

<style>
#wrap {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 1031;
  font-size: 1.2em;
}
.jipvioPopUp {
  background-color: white;
  height: 100%;
  overflow-y: auto;
}
.jipvioPopUp header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 85px;
  z-index: 201;
  text-align: center;
  background: #fff;
}
.jipvioPopUp header .btn-right {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 1.5em;
  cursor: pointer;
  z-index: 1;
}

.jipvioPopUp .JipvioContainer {
  position: relative;
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0;
  margin: 0 auto;
  padding-top: 79px;
}

@media only screen and (min-width: 576px) {
  #wrap {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    font-size: 1em;
  }

  .jipvioPopUp {
    width: 500px;
    max-height: 650px;
    background-color: white;
    z-index: 5000;
    border: 1px solid #cdcdcd;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.6);
    box-sizing: border-box;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .jipvioPopUp .JipvioContainer {
    overflow-y: auto;
    text-align: left;
    min-height: inherit;
    max-height: inherit;
  }
}
</style>
